import "../../../resources/less/Family/ThemePages/MyNeighborhood.less";
import BaseThematique from "./BaseThematique";

class MyNeighborhood extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new MyNeighborhood();
});
